/** Canonical origin (aligned with robots.txt / sitemap and OG defaults). */
export const SITE_ORIGIN = 'https://www.riftbound-db.com';

export const SITE_NAME = 'Riftbound DB';

/** Primary keyword bundle for meta keywords + copy consistency (keep in sync with index.html where relevant). */
export const SITE_SEO_KEYWORDS =
  'Riftbound TCG, Riot Riftbound, League of Legends card game, Riftbound cards, Riftbound card database, Riftbound card list, Riftbound card search, Riftbound collection tracker, Riftbound card scanner, scan Riftbound cards, Riftbound print proxies, Riftbound deck builder, Riftcodex, trading card game, physical TCG';

export const SITE_SEO_HOME_TITLE = 'Riftbound Card Database & Deck Builder | Riftbound DB';

export const SITE_SEO_HOME_DESCRIPTION =
  'Search the full Riftbound TCG card database: filter by region, domain, champion, keyword, cost, might, and rarity. Scan physical cards with your phone camera to instantly add them to your collection. Brew decks with validation and guides, export lists, and build print-ready proxy PDFs.';
